module.exports = __webpack_public_path__ + "img/safari-pinned-tab.f22d501a.svg";